/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { color, device, Common } from '@stockbit/ui';
import { assetPrefix } from 'constants/app';

const { Flex } = Common;

export const Container = styled.section`
  padding: 30px;
  margin: 50px auto;
  height: 100%;

  @media ${device.tablet} {
    padding: 0;
    max-width: 1300px;
    width: calc(100% - 150px);
  }
}`;

export const Header = styled.section`
  height: 176px;
  margin-top: 100px;
  background-color: ${color.snow};

  @media ${device.tablet} {
    height: 260px;
  }
`;

export const HeaderContent = styled(Flex).attrs({
  justify: 'center',
  direction: 'column',
})`
  height: 100%;
  h1 {
    font-size: 28px;

    @media ${device.tablet} {
      font-size: 36px;
    }

    @media ${device.laptop} {
      font-size: 6.5vh;
    }

    @media ${device.laptopL} {
      font-size: 44px;
    }
  }

  p {
    font-size: 17px;

    @media ${device.tablet} {
      font-size: 19px;
    }
  }
`;

export const ContactContainer = styled.div`
  display: block;

  @media ${device.laptop} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 25px;
    grid-row-gap: 0px;
  }
`;

export const ContactBox = styled.div`
  border: 1px solid ${color.gainsboro};
  border-radius: 10px;
  margin-bottom: 25px;

  .address {
    margin: 22px;
    background: url(${assetPrefix}/images/pin.png) no-repeat top left;
    padding-left: 68px;
  }

  h5 {
    font-size: 16px;

    @media ${device.tablet} {
      font-size: 24px;
      margin-bottom: 10px;
    }
  }

  p {
    font-size: 14px;

    @media ${device.tablet} {
      font-size: 18px;
      margin-bottom: 20px;
    }
  }
`;

export const ContactInner = styled.div`
  padding: 40px 30px;

  h5 {
    font-size: 18px;
    margin-bottom: 20px;
    @media ${device.tablet} {
      font-size: 24px;
    }
  }

  p,
  span {
    font-size: 14px;
    margin-bottom: 20px;
    @media ${device.tablet} {
      font-size: 18px;
    }
  }
`;

export const GoogleMapContainer = styled.div`
  height: 448px;
`;
